<template>
    <div id="buildings-manager">
        <v-card ref="buildingsManagerCard">
            <v-card-title>
                Buildings Manager
                <v-spacer></v-spacer>
                <buildings-add v-if="getAccess()" @refreshData="refreshData" @setNotification="setNotification">
                </buildings-add>
            </v-card-title>
            <v-card-text>
                <v-data-table :headers="headers" :items="data" sort-by="name">
                    <template v-slot:item.actions="{ item }">
                        <buildings-edit v-if="getAccess()" :item="item" @refreshData="refreshData"
                            @setNotification="setNotification">
                        </buildings-edit>
                        <buildings-delete v-if="getAccess()" :item="item" @refreshData="refreshData"
                            @setNotification="setNotification">
                        </buildings-delete>
                        <v-btn @click="downloadContractCondition(item)" :color="primaryColor"
                            :disabled="!item.fileContractConditions || !item.fileContractConditions.file || !item.fileContractConditions.fileNormalized"
                            icon>
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-icon v-bind="attrs" v-on="on">
                                        mdi-download
                                    </v-icon>
                                </template>
                                <span>Download Contract Conditions</span>
                            </v-tooltip>
                        </v-btn>
                        <v-btn @click="openInfoBuildingDialog(item)" :color="infoColor" icon>
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-icon v-bind="attrs" v-on="on">
                                        mdi-information
                                    </v-icon>
                                </template>
                                <span>More Information</span>
                            </v-tooltip>
                        </v-btn>
                    </template>
                    <template v-slot:item.international="{ item }">
                        {{ getInternationalLabel(item) }}
                    </template>
                    <template v-slot:item.status="{ item }">
                        <v-chip :color="getStatusColor(item)" small>
                            {{ getStatusLabel(item) }}
                        </v-chip>
                    </template>
                </v-data-table>
                <buildings-info :currentBuilding="currentBuilding" :infoBuildingDialog="infoBuildingDialog"
                    @closeInfoBuildingDialog="closeInfoBuildingDialog">
                </buildings-info>
            </v-card-text>
        </v-card>
    </div>
</template>

<script>
import BuildingsAdd from './AddBuilding';
import BuildingsDelete from './DeleteBuilding';
import BuildingsEdit from './EditBuilding';
import BuildingsInfo from './InfoBuilding';

export default {
    name: 'building-manager',
    components: {
        BuildingsAdd,
        BuildingsDelete,
        BuildingsEdit,
        BuildingsInfo
    },
    props: {
        data: {
            required: true,
            type: Array
        },
        permission: {
            required: true,
            type: Object
        }
    },
    data() {
        return {
            currentBuilding: '',
            headers: [{
                    text: 'Name',
                    align: 'start',
                    value: 'name',
                },
                {
                    text: 'Max Roommate Request',
                    value: 'maxRoommateRequest',
                },
                {
                    text: 'Min Year of Study',
                    value: 'minYearOfStudy',
                },
                {
                    sortable: false,
                    text: 'Intl. only',
                    value: 'international',
                },
                {
                    sortable: false,
                    text: 'Max Occupancy',
                    value: 'maxOccupancy',
                },
                {
                    sortable: false,
                    text: 'Enabled',
                    value: 'status',
                },
                {
                    sortable: false,
                    text: 'Actions',
                    value: 'actions'
                }
            ],
            infoBuildingDialog: false
        }
    },
    methods: {
        closeInfoBuildingDialog() {
            this.infoBuildingDialog = false;
        },
        downloadContractCondition(item) {
            let data = JSON.stringify({
                file: item.fileContractConditions.file,
                fileNormalized: item.fileContractConditions.fileNormalized
            });

            window.open(`https://${location.hostname}/cgi-bin/res-app-api/controller.api.pl?download&data=${data}`);
        },
        getAccess() {
            if (this.permission.enabled == "1" && this.permission.access == "write") {
                return true;
            }

            return false;
        },
        getInternationalLabel(item) {
            if (item.hasOwnProperty('internationalOnly') && item.internationalOnly == "1") {
                return 'Yes';
            } else if (item.hasOwnProperty('internationalOnly') && item.internationalOnly == "0") {
                return 'No';
            }

            return 'Not specified';
        },
        getStatusColor(item) {
            if (item.hasOwnProperty('enabled') && item.enabled == "1") {
                return '#1dc9b7';
            }

            return '#f64e60';
        },
        getStatusLabel(item) {
            if (item.hasOwnProperty('enabled') && item.enabled == "1") {
                return 'Enabled';
            }

            return 'Disabled';
        },
        openInfoBuildingDialog(item) {
            this.currentBuilding = item;
            this.infoBuildingDialog = true;
        },
        refreshData() {
            this.$emit('refreshData');
        },
        setNotification(color, icon, message, status) {
            this.$emit('setNotification', color, icon, message, status);
        }
    },
    computed: {
        infoColor() {
            return '#5578eb';
        },
        primaryColor() {
            return '#5867dd';
        },
    }
}
</script>